import { BASE_Action } from "../../Core/Redux/BaseAction";

export const SNACKBAR_OPEN = '@snackbar/SNACKBAR_OPEN';

export interface SnackbarOptions {
    open?: boolean;
    message?: string;
    anchorOrigin?: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'center' | 'right' };
    variant?: string;
    alertSeverity?: 'success' | 'error' | 'warning' | 'info';
    transition?: string;
    close?: boolean;
    actionButton?: boolean;
}

export type SNACKBARActionTypes = BASE_Action<typeof SNACKBAR_OPEN, SnackbarOptions>;